import { render } from "./MealsList.vue?vue&type=template&id=0f4acade&scoped=true"
import script from "./MealsList.vue?vue&type=script&lang=js"
export * from "./MealsList.vue?vue&type=script&lang=js"

import "./MealsList.vue?vue&type=style&index=0&id=0f4acade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4acade"]])

export default __exports__